module.exports = __webpack_public_path__ + "9bf4b59214a5a8a588b37679f1041a4c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/monetize_your_content.png
// module id = 193
// module chunks = 0